import { Table, TableBody, TableHeader } from '@library/components/table';
import { NoResults } from '@library/components/NoResults';
import type { TableColumn } from '@library/types/utils';

export interface TradeHistoryTableProps {
  children: Array<JSX.Element> | undefined;
  headers: Array<TableColumn>;
  showEmpty: boolean;
}

export const TradeHistoryTable = ({
  children,
  headers,
  showEmpty
}: TradeHistoryTableProps) => {
  return (
    <Table className="border-soFresh-140 overflow-auto rounded-lg border p-0">
      <TableHeader
        buttonClassName="text-center"
        className="bg-soFresh-110 sticky top-0 z-10 w-full p-0"
        headers={headers}
      />
      <TableBody className="max-h-80 w-full">
        {showEmpty ? (
          <div className="w-full p-2">
            <NoResults label="No History found for this Player, Stat Type and Game" />
          </div>
        ) : (
          children
        )}
      </TableBody>
    </Table>
  );
};
